import { StyledIssueButton } from './IssueButton.style';
import issuebtn from '/assets/image/help_button.svg';

export const IssueButton = () => {
  const handleClick = () => {
    window.open(
      'https://box3-support.nani.com.tw/hc/zh-tw',
      '_blank',
      'noopener,noreferrer',
    );
  };

  return (
    <StyledIssueButton onClick={handleClick}>
      <img src={issuebtn} alt="issue button" style={{ height: '100%' }} />
    </StyledIssueButton>
  );
};
